import { render, staticRenderFns } from "./SidoCodeDetail.vue?vue&type=template&id=4b12ad07&scoped=true"
import script from "./SidoCodeDetail.vue?vue&type=script&lang=js"
export * from "./SidoCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./SidoCodeDetail.vue?vue&type=style&index=0&id=4b12ad07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12ad07",
  null
  
)

export default component.exports